import { useDispatch, useSelector } from 'react-redux';
import dynamicfunction from '../../utils/dynamicfunction';
import { useLocation, useNavigate } from 'react-router';
import { setApplicantType, setClientApplicationId, setKsaCorporate, setRejectionMsg } from '../../store/slices/constantSlice';
import { createCorpApplication, generateAuthToken } from '../../store/actions/corporateAction';
import { useEffect } from 'react';
import { getContentKeyAccToLang } from '../../utils/utils';
export default () => {
  const { isArabic, TextWeight, direction } = dynamicfunction();

  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();

  const { auth_content } = useSelector((state) => state.common);
  const { eligibleAccounts, eligible_accounts_loading } = useSelector((state) => state.auth);
  const { nafath_loading } = useSelector((state) => state.corporate);
  const { authContent, language } = useSelector((state) => state.content);
  const getContentKey = (key) => {
    return getContentKeyAccToLang(authContent?.web_open_new_account?.data?.attributes, key, isArabic);
  };

  const user = location.state?.data;


  const onPressApplication = (item) => {
    dispatch(setClientApplicationId(item?.applicationId));
    dispatch(setRejectionMsg(item?.rejectionReason ?? null));
    const is_corp = item?.investorTypeId === 2;

    const api_data = {
      token: user?.token, languageId: user?.languageId,
      accountInfo: { accountId: item?.accountId, isCorp: is_corp ? true : false }
    }
  };

  return {
    isArabic, TextWeight, direction, eligibleAccounts, onPressApplication, eligible_accounts_loading, getContentKey, navigate
  };
};
